"use client";

import { Heart, House as Home } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompanyExpertise() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const infoTiles = [{
    icon: Home,
    label: "Commercial Projects",
    value: "150+",
    sublabel: "climate systems installed"
  }, {
    icon: Heart,
    label: "Happy Clients",
    value: "500+",
    sublabel: "trusting our expertise"
  }];
  return <section data-section-id="801" id="companyexpertise" className="relative overflow-hidden bg-background py-24 md:py-[120px]">
      {}
      <div className="pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/3 md:translate-x-1/4 lg:translate-x-1/4 xl:translate-x-1/3">
        <div className="h-[320px] w-[320px] md:h-[520px] md:w-[520px] xl:h-[640px] xl:w-[640px] bg-cover bg-center opacity-90" style={{
        backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/air_conditioning_unit_tech.png)",
        clipPath: "polygon(25% 6.7%, 75% 6.7%, 100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%)"
      }} />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div className="lg:col-span-5">
            <div ref={leftRef} className={`lg:sticky lg:top-28 transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              <div className="flex items-center gap-3 mb-10">
                <span className="font-default text-xs uppercase tracking-[0.2em] text-muted-foreground [writing-mode:vertical-rl] rotate-180 lg:[writing-mode:horizontal-tb] lg:rotate-0">
                  02 / Our Expertise
                </span>
                <span className="hidden lg:block h-px w-12 bg-foreground/30" />
              </div>

              <h2 className="font-default text-5xl md:text-6xl lg:text-[72px] leading-[1.02] tracking-tight text-foreground">
                Precision{" "}
                <em className="italic font-medium text-primary">
                  Climate Control
                </em>
              </h2>

              <div className="mt-10 flex items-center gap-4">
                <Badge className="bg-primary text-primary-foreground border-transparent px-4 py-2 font-default text-[11px] uppercase tracking-[0.18em]" style={{
                clipPath: "polygon(25% 6.7%, 75% 6.7%, 100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%)"
              }}>
                  <span className="px-2">Coastline Certified</span>
                </Badge>
                <span className="font-default text-xs text-muted-foreground">
                  — Professional HVAC Solutions
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div ref={rightRef} className={`transition-all duration-700 delay-150 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              {}
              <p className="font-default text-[22px] md:text-[26px] leading-[1.35] font-medium text-foreground">
                Delivering superior air conditioning and climate management for 
                commercial and residential spaces across Sussex and Surrey. 
                We ensure your environment remains perfectly balanced year-round.
              </p>

              {}
              <p className="mt-8 font-default text-[17px] leading-[1.7] text-muted-foreground max-w-2xl">
                Our <span className="text-foreground font-medium">Installation Services</span>{" "}
                provide bespoke climate control systems tailored to your building's 
                unique architecture. Need reliable care? Our <span className="text-foreground font-medium">Maintenance Plans</span>{" "}
                ensure your units operate at peak efficiency, reducing energy costs 
                and extending the lifespan of your equipment through every season.
              </p>

              {}
              <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {infoTiles.map((tile, i) => {
                const Icon = tile.icon;
                return <div key={i} data-index={i} className="group relative bg-card p-6 rounded-lg border border-border/60 transition-all duration-300 hover:border-primary/40 hover:-translate-y-0.5">
                      <div className="flex items-start gap-3 mb-4">
                        <div className="flex items-center justify-center w-9 h-9 rounded-md bg-primary/10">
                          <Icon className="w-4 h-4 text-primary" />
                        </div>
                        <span className="font-default text-[11px] uppercase tracking-[0.16em] text-muted-foreground pt-2.5">
                          {tile.label}
                        </span>
                      </div>

                      <div className="font-default text-4xl text-foreground leading-none">
                        {tile.value}
                      </div>
                      <p className="mt-2 font-default text-sm text-muted-foreground">
                        {tile.sublabel}
                      </p>

                      {}
                      <div className="mt-5 h-px w-12 bg-primary transition-all duration-300 group-hover:w-20" />
                    </div>;
              })}
              </div>

              {}
              <div className="mt-12 flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-7 h-12 font-default text-sm tracking-wide">
                  
                </Button>
                <Button asChild variant="outline" size="lg" className="border-primary/20 bg-transparent text-foreground hover:bg-primary/5 rounded-lg px-7 h-12 font-default text-sm tracking-wide">
                  
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}